import { getPathName } from './locationUtils';

export function getBasePath() {
  const versionedBasePathMatch = getPathName() && getPathName().match('^(/v2-proxy/version-.*?)/');
  return versionedBasePathMatch ? versionedBasePathMatch[1] : '/v2';
}
